module.exports = __webpack_public_path__ + "static/media/KW900-01-14.79a9dc46.jpg";